import { Box } from "@mui/material";
import { AuthLayoutWrapper } from "./styled";
import { AuthLogo } from "../../../assets";
import { Favicon } from "../../../assets";
import { AuthLayoutPropsType } from "../../../types/app.type";

export const AuthLayout: React.FC<AuthLayoutPropsType> = ({ children }) => {
    return (
        <AuthLayoutWrapper>
            <Box
                component={"div"}
                className="form-box"
            >
                <Box
                    className="favicon-box"
                >
                    <Favicon />
                </Box>
                {children}
            </Box>
            <Box
                component={"div"}
                className="logo-box"
            >
                <AuthLogo />
            </Box>
        </AuthLayoutWrapper>
    )
}